'use client';

import { usePathname } from 'next/navigation';
import { FeatureFlag } from '@/common/constants/feature-flag.enum';
import { useFeatureFlag } from '@/common/hooks/use-feature-flag.hook';
import MobileBottomNavigation from '@/features/shop/components/mobile-bottom-navigation.component';
import { selectIsTenant, useDomainStore } from '@/store/use-domain.store';

const NO_BOTTOM_NAV_PATHS = [
  '/privacy-policy',
  '/terms-of-service',
  '/faq',
  '/contact',
  '/contact-us',
  '/invoice',
  '/profile',
] as const;

/** PDP routes: /{vendorSlug}/{productId}/... where productId is numeric. */
function isProductDetailPath(pathname: string) {
  const parts = pathname.split('/').filter(Boolean);
  return parts.length >= 2 && /^\d+$/.test(parts[1] ?? '');
}

export function shouldHideMobileBottomNav(pathname: string | null | undefined) {
  if (!pathname) return false;
  if (isProductDetailPath(pathname)) return true;
  return NO_BOTTOM_NAV_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
}

export function WitroMobileBottomNavigation() {
  const isTenant = useDomainStore(selectIsTenant);
  const pathname = usePathname();
  const isWitroHomepageEnabled = useFeatureFlag(
    FeatureFlag.ShopperWitroHomepage
  );

  if (
    !isWitroHomepageEnabled ||
    isTenant ||
    shouldHideMobileBottomNav(pathname)
  ) {
    return null;
  }
  return <MobileBottomNavigation />;
}

export function WitroMobileNavOffset() {
  const isTenant = useDomainStore(selectIsTenant);
  const pathname = usePathname();
  const isWitroHomepageEnabled = useFeatureFlag(
    FeatureFlag.ShopperWitroHomepage
  );

  if (
    !isWitroHomepageEnabled ||
    isTenant ||
    shouldHideMobileBottomNav(pathname)
  ) {
    return null;
  }
  return (
    <div
      className="h-16 pb-[max(2px,env(safe-area-inset-bottom))] lg:hidden"
      aria-hidden
    />
  );
}
